<template>
  <div class="email-application">
    <div class="content-area-wrapper">
      <div class="email-app-list full-width">
        <vue-perfect-scrollbar
          :settings="{
            maxScrollbarLength: 150,
          }"
          class="email-user-list scroll-area"
        >
          <ul class="email-media-list">
            <b-media
              v-for="message in messages"
              :key="message.Id"
              tag="li"
              no-body
            >
              <b-media-body>
                <div class="mail-details">
                  <div class="mail-items">
                    <h5 class="mb-25">
                      {{ message.Title }}
                    </h5>
<!--                    <span class="text-truncate">{{ message.Segment }}</span>-->
                  </div>
                  <div class="mail-meta-item">
                    <span class="mail-date">{{ message.SendTime | date }}</span>
                    <span class="mail-date ml-1">{{ enums('sendVia',"value",message.Type,"text") }}</span>
                  </div>
                </div>
                <div class="mail-message">
                  <p class="text-truncate mb-0">
                    {{ message.Description }}
                  </p>
                </div>
              </b-media-body>
            </b-media>
          </ul>
          <div
            class="no-results"
            :class="{'show': !messages.length}"
          >
            <h5>هیچ پیامی ارسال نشده است</h5>
          </div>
        </vue-perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MessageInbox',
  props: ['userId'],
  data() {
    return {
      messages: [],
    }
  },
  created() {
    this.messageList()
  },
  methods: {
    messageList() {
      this.$http.post(this.$api.declarations.getlist, {
        PerPage: 50,
        Page: 1,
        UserId: this.userId,
      }).then(response => {
        this.messages = response.data
      })
    },
  },
}
</script>

<style lang="scss">
</style>
